/**
 * Cart button inside the mobile menu drawer.
 *
 * Horizon's declarative bindings take exactly one action per element —
 * `assets/component.js` does `value.split('/')` and resolves a single
 * selector/method pair — so `on:click` cannot both close this drawer and open the
 * cart. This wires the two together instead.
 *
 * The markup is a real `<a href="/cart">`, so with JS unavailable the link still
 * works; we only take over when the cart drawer is actually present.
 */

if (!window.__customDrawerCartWired) {
  window.__customDrawerCartWired = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const trigger = target.closest('[data-custom-drawer-cart]');
    if (!trigger) return;

    const cartDrawer = document.querySelector('#cart-drawer');
    // No cart drawer on this page: let the anchor navigate to /cart as written.
    if (typeof cartDrawer?.toggle !== 'function') return;

    event.preventDefault();

    const menuDrawer = trigger.closest('header-drawer');
    if (typeof menuDrawer?.close === 'function') menuDrawer.close();

    // One frame of breathing room: `close()` releases the menu's scroll lock
    // synchronously, and opening the dialog in the same tick can leave the two
    // fighting over it, which unlocks the page behind the cart.
    requestAnimationFrame(() => cartDrawer.toggle());
  });
}
